module.exports = {
  siteTitle: "SteveFox.io - Technology Consultant", // <title>
  shortSiteTitle: "SteveFox.io", // <title> ending for posts and pages
  siteDescription: "Hire a Technology Consultant",
  siteUrl: "http://www.stevefox.io",
  pathPrefix: "",
  siteImage: "preview.jpg",
  siteLanguage: "en",
  // author
  authorName: "steve fox",
  authorTwitterAccount: "stevefoxIO",
  // info
  headerTitle: "steve fox",
  headerSubTitle: "technology consultant",
  // manifest.json
  manifestName: "SteveFox.io - Technology Consulting",
  manifestShortName: "SteveFox.io", // max 12 characters
  manifestStartUrl: "/index.html",
  manifestBackgroundColor: "white",
  manifestThemeColor: "#272822",
  manifestDisplay: "standalone",
  // social
  authorSocialLinks: [
    { name: "github", url: "https://github.com/stevefox" },
    { name: "linkedin", url: "https://linkedin.com/in/stfox" }
  ]
};



// WEBPACK FOOTER //
// ./content/meta/config.js